// src/api.js
import axios from 'axios';
import config from './config';

// Resolve base URL with production safety for HTTPS
let resolvedBase =
  process.env.REACT_APP_API_BASE_URL ||
  process.env.VITE_API_BASE_URL ||
  config.apiBaseUrl ||
  '/api';

// If page is HTTPS and base is plain HTTP, force relative '/api' to avoid mixed content
if (
  typeof window !== 'undefined' &&
  window.location &&
  window.location.protocol === 'https:' &&
  /^http:\/\//i.test(resolvedBase)
) {
  resolvedBase = '/api';
}

const api = axios.create({
  baseURL: resolvedBase,
  withCredentials: true,
});

export default api;



